import { UDListItem, UDText } from 'ud-ui/components';

import CategoryListPage from 'ud-ui/components/category/pages/category-list-page';
import HeaderContentCategory from 'ud-ui/components/category/components/list-wrapper/header-content';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { useMainLayout } from 'ud-ui/layout/main/context';
import UDButton from 'ud-ui/components/button';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTeamList } from 'modules/teams/ui/hooks/use-teams-list';
import Modal from 'ud-ui/components/modal';
import { TEAM_DEFAULT_LOGO } from 'shared/constants/links';

type Source = 'common' | 'players';
const naming = {
  searchPlaceholder: 'Поиск по командам',
  addButtonText: 'Добавить команду',
};

const TeamsPage = () => {
  const navigate = useNavigate();
  const handleCreateClick = useCallback(() => {
    navigate(Pages.TEAMS.CREATE);
  }, [navigate]);
  const { setHeaderContent } = useMainLayout();

  const { isLoading, teams, loadNextPages, changeFilter, teamsByFilter } = useTeamList();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const openDelete = useCallback(() => {
    setIsOpenModal(true);
  }, []);
  const closeDelete = useCallback(() => {
    setIsOpenModal(false);
  }, []);

  const handleEditInfoClick = useCallback(
    (team: { id: number }, source: Source) => {
      navigate(Pages.TEAMS.builders.edit(team.id, source));
    },
    [navigate],
  );

  useEffect(() => {
    setHeaderContent(
      <HeaderContentCategory title="Команды" createButtonText="Добавить команду" createButtonOnClick={handleCreateClick} />,
    );
    return () => setHeaderContent(null);
  }, [handleCreateClick, setHeaderContent]);

  return (
    <>
      <CategoryListPage
        categoryName="teams"
        text={naming}
        isLoading={isLoading}
        getNextPages={loadNextPages}
        getFiltered={changeFilter}
        onCreateClick={handleCreateClick}
      >
        {(teamsByFilter || teams).map((team, index) => {
          return (
            <UDListItem
              key={team.id}
              index={index + 1}
              image={team.logo?.url ?? TEAM_DEFAULT_LOGO}
              className="white mb-2"
              title={team.name}
              subtitle={
                <div className="d-flex justify-content-between w-100" style={{ fontWeight: 400 }}>
                  <p className="mr-1">Дата создания: {team.createdAt ?? '-'}</p>
                  <p style={{ minWidth: 80 }}>Состав: {team.players.length}</p>
                </div>
              }
              actions={[
                {
                  label: 'Удалить',
                  onClick: openDelete,
                  variant: 'secondary',
                  style: { width: 144 },
                },
              ]}
              onClick={() => handleEditInfoClick(team, 'common')}
            />
          );
        })}
      </CategoryListPage>

      <Modal show={isOpenModal} onClose={closeDelete}>
        <Modal.Body>
          <UDText type="body-text">В данный момент функционал в разработке</UDText>
          <UDText type="subhead">Приносим свои извинения за доставленные неудобства</UDText>{' '}
        </Modal.Body>
        <Modal.Footer>
          <UDButton variant="primary" onClick={closeDelete} stretch>
            ОК
          </UDButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TeamsPage;
